import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle, Spinner } from "@phosphor-icons/react";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired" || attempts > 8) { setStatus("error"); return; }
      } catch { if (attempts > 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, []);

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
        className="bg-card border border-border rounded-2xl p-8 text-center max-w-md w-full">
        {status === "checking" && (
          <><Spinner size={48} className="mx-auto text-primary animate-spin" /><h1 className="font-heading text-xl font-bold mt-4">Verifica pagamento…</h1></>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={56} weight="fill" className="mx-auto text-emerald-500" />
            <h1 className="font-heading text-2xl font-bold mt-4">Prenotazione confermata!</h1>
            <p className="text-muted-foreground mt-2">Il tuo pagamento è andato a buon fine. Trovi i dettagli nelle tue prenotazioni.</p>
            <Button className="rounded-full mt-6 w-full" data-testid="to-dashboard" onClick={() => navigate("/dashboard")}>Le mie prenotazioni</Button>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-heading text-xl font-bold">Impossibile verificare</h1>
            <p className="text-muted-foreground mt-2">Controlla lo stato nelle tue prenotazioni.</p>
            <Button className="rounded-full mt-6 w-full" onClick={() => navigate("/dashboard")}>Vai alla dashboard</Button>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default PaymentSuccess;
